export default __webpack_public_path__ + "static/media/info.84c3d460.svg";